import { Stack, TextField } from '@mui/material';
import { useTranslate } from 'react-admin';
import { DisplayText } from './types';

interface Props {
  value: DisplayText;
  onChange: (v: DisplayText) => void;
  labelPrefix: string; // e.g. 'module.perpsV1Shared.label' -> `${labelPrefix}Slug|En|Zh`
  slugPlaceholder?: string;
}

// slug / en / zh 三元组输入：slug 为 i18n key（留空由后端按规则生成），en/zh 为运营覆盖值
export function DisplayTextFields({ value, onChange, labelPrefix, slugPlaceholder }: Props) {
  const translate = useTranslate();
  const set = (patch: Partial<DisplayText>) => onChange({ ...value, ...patch });
  return (
    <Stack direction="row" spacing={1}>
      <TextField
        size="small"
        fullWidth
        label={translate(`${labelPrefix}Slug`)}
        placeholder={slugPlaceholder}
        value={value.slug ?? ''}
        onChange={(e) => set({ slug: e.target.value || null })}
      />
      <TextField
        size="small"
        fullWidth
        label={translate(`${labelPrefix}En`)}
        value={value.en ?? ''}
        onChange={(e) => set({ en: e.target.value || null })}
      />
      <TextField
        size="small"
        fullWidth
        label={translate(`${labelPrefix}Zh`)}
        value={value.zh ?? ''}
        onChange={(e) => set({ zh: e.target.value || null })}
      />
    </Stack>
  );
}
